import { Alert } from "./Alert";

import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { Email, sendEmail, resetState } from "../emailSlice";
import { useEffect } from "react";
import { clearAlert, infoAlert } from "../appSlice";

import styled from 'styled-components'
import { InputRow } from "./widgets/InputRow";
import { TextareaRow } from "./widgets/TextareaRow";

const Wrap = styled.article`
  .form {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 0.5fr;
    row-gap: 0.1rem;
  }
  article:nth-of-type(1) {
    grid-column: 1 / 2; grid-row: 1 / 2;
  }
  article:nth-of-type(2) {
    grid-column: 1 / 2; grid-row: 2 / 3;
  }
  article:nth-of-type(3) {
    grid-column: 1 / 2; grid-row: 3 / 4;
  }
  article:nth-of-type(4) {
    grid-column: 1 / 2; grid-row: 4 / 5;
  }
  .btn-pink {
    grid-column: 1 / 2; grid-row: 5 / 6;
  }

  @media (min-width: 992px) {
    .form {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr 1fr 0.5fr;
      column-gap: 0.5rem;
      row-gap: 0rem;
    }
    article:nth-of-type(1) {
      grid-column: 1 / 2; grid-row: 1 / 2;
    }
    article:nth-of-type(2) {
      grid-column: 2 / 3; grid-row: 1 / 2;
    }
    article:nth-of-type(3) {
      grid-column: 1 / 3; grid-row: 2 / 3;
    }
    article:nth-of-type(4) {
      grid-column: 1 / 3; grid-row: 3 / 4;
    }
    .btn-pink {
      grid-column: 2 / 3; grid-row: 4 / 5;
    }
  }
    
  .form-center {
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 2rem;
    row-gap: 0.5rem;
  }
`


export const EmailUsForm = () => {
  const appstate = useAppSelector(state => state.appstate);

  const dispatch = useAppDispatch();


  const { control, handleSubmit, reset, formState, formState: { isSubmitSuccessful } } = useForm<Email>({ defaultValues: {} as Email });

  //useEffect Hook = componentDidMount, componentDidUpdate, and componentWillUnmount combined
  //useEffect is a child component of EmailUsForm
  //useEffect (as the child component) is invoked first (follows rule: child component invoke first)
  useEffect(() => {

    if (formState.isSubmitSuccessful) {
      dispatch(resetState());
      reset();
    }

    setTimeout(() => {
      dispatch(clearAlert());
    }, 3000)
  }, [formState, isSubmitSuccessful, reset]);

  const onSubmit: SubmitHandler<Email> = async (data: Email) => {
    await dispatch(sendEmail(data));
    console.log('onsubmitting -> infoAlert()')
    dispatch(infoAlert('email sent'));

  }

  return (
    <Wrap>
      {appstate.showAlert && <Alert />}
      <form onSubmit={handleSubmit(onSubmit)} className="form">
        <Controller name="senderName" rules={{ required: 'your name is required' }} control={control} render={({ field, formState: {errors} }) =>
          <InputRow {...field} value={field.value} error={errors.senderName?.message} type="input" className="form-input" label="Your Name *" />} />
        <Controller name="senderEmail" rules={{ required: {value: true, message: 'email is required'}, pattern: {value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message:'email must be valid' }}} control={control} render={({ field, formState: {errors} }) =>
          <InputRow {...field} value={field.value} error={errors.senderEmail?.message} type="input" className="form-input" label="Your Email *" />} />
        {/* <Controller name="subject" control={control} render={({ field, formState: {errors} }) =>
          <InputRow {...field} value={field.value} error={errors.subject?.message} type="input" className="form-input" label="Subject" />} />
        <Controller name="message" rules={{ required: 'you must have something to say' }} control={control} render={({ field, formState: {errors} }) =>
          <TextareaRow {...field} value={field.value} error={errors.message?.message} cols={30} rows={5} className="form-textarea" label="Message *" />} /> */}
        <button
          type='submit'
          className='btn-pink' style={{margin: '0px 0px 0px auto'}}
          >
          Submit
        </button>
      </form>
    </Wrap>
  )

}